import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/operate/poc.png'


const _withScopeId = n => (_pushScopeId("data-v-8a0f2d38"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "m-b-10" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "poc_img",
  alt: ""
}, null, -1))

import { ref, onMounted, onBeforeUnmount, computed } from "vue";
import { inviteCodePocRead, inviteCodePocDownload } from "@/api/request/poc";
import { download } from "@/utils/download"; 
import { useI18n } from "vue-i18n";

export default /*#__PURE__*/_defineComponent({
  __name: 'poc',
  setup(__props) {

const { t } = useI18n(); 

const showPocDialog = ref(false);
const isClosing = ref(false);
let closeTimer: ReturnType<typeof setTimeout> | null = null;

const pocDialog = ref<InstanceType<typeof import("element-plus").ElDialog> | null>(null);
const dialogStyle = computed(() => {
    if (!isClosing.value) {
        return {
            opacity: 1,
            transform: "translate(0, 0) scale(1)",
            transformOrigin: "top right",
            transition: "transform 0.35s ease, opacity 0.35s ease",
            overflow: "hidden",
        };
    }
 
    const {top,right} = (pocDialog.value?.dialogContentRef.$el?.getBoundingClientRect()); 
  
    //计算translateX
    var translateX = right - 830 - 100; 
    var translateY = top>50?50-top:50-top;

    return {
        opacity: 0,
        transform: `translate(${translateX}px, ${translateY}px) scale(0.12)`,
        transformOrigin: "top right",
        transition: "transform 0.5s ease, opacity 1.5s ease",
        overflow: "hidden",
    };
});

function handleBeforeClose(done: () => void) {
    if (isClosing.value) return;

    isClosing.value = true;

    closeTimer && clearTimeout(closeTimer);
    closeTimer = setTimeout(() => {
        
        done();
        setTimeout(() => {
            isClosing.value = false;
        }, 100); 
    }, 1500);
}

onMounted(async () => {
    const { code, data } = await inviteCodePocRead();
    if (String(code) === "00" && Number(data) > 0) {
        showPocDialog.value = true;
    }
});

onBeforeUnmount(() => {
    if (closeTimer) {
        clearTimeout(closeTimer);
    }
});

const handleDownload = () => {
    inviteCodePocDownload().then((res:any) => { 
        const _blob = new Blob([res]);
        const blobUrl = URL.createObjectURL(_blob);
        const _t = new Date().getTime();
        download(blobUrl, _t + ".csv");
    });
};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    ref_key: "pocDialog",
    ref: pocDialog,
    title: "",
    modelValue: showPocDialog.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showPocDialog).value = $event)),
    width: "830px",
    "close-on-click-modal": false,
    "close-on-press-escape": false,
    "before-close": handleBeforeClose,
    "append-to-body": true,
    style: _normalizeStyle(_unref(dialogStyle))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, {
            span: 12,
            class: "box box-align-center"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(["poc_container", { 
                    'en': _ctx.$i18n.locale === 'en-US',
                }])
              }, [
                _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('认证考试邀请码')), 1),
                _createVNode(_component_el_button, {
                  type: "primary",
                  size: "default",
                  onClick: handleDownload
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('下载')), 1)
                  ]),
                  _: 1
                })
              ], 2)
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            span: 12,
            class: "p-b-20"
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue", "style"]))
}
}

})